import * as React from "react";
import { CennaLogo } from "../primitives/Avatar";
import { ChatSuggestionChips } from "./ChatSuggestionChips";

export type ChatEmptyStateProps = {
  onSuggestionClick: (text: string) => void;
  hasSelectedText: boolean;
  /** When set, hide chips and show this access / permission message instead. */
  accessDeniedMessage?: string | null;
};

export const ChatEmptyState: React.FC<ChatEmptyStateProps> = ({
  onSuggestionClick,
  hasSelectedText,
  accessDeniedMessage = null,
}) => (
  <div className="chat-empty">
    <div className="chat-empty__hero">
      <div className="chat-empty__logo">
        <CennaLogo size={36} />
      </div>
      <div className="chat-empty__title">Ask Cenna</div>
      <div className="chat-empty__sub">
        {accessDeniedMessage
          ? accessDeniedMessage
          : "Ask questions about this document or get suggestions for edits."}
      </div>
    </div>
    {!accessDeniedMessage ? (
      <div className="chat-empty__chips">
        <ChatSuggestionChips onSelect={onSuggestionClick} hasSelectedText={hasSelectedText} />
      </div>
    ) : null}
  </div>
);
